<template>
  <div class="notifications">
    <v-layout column wrap justify-end align-center class="notifications-layout">
      <div v-for="(alert, i) in notifications" class="notification" :key="i">
        <v-scale-transition>
          <v-alert
            :type="alertType(alert)"
            :icon="false"
            :dense="$vuetify.breakpoint.xs"
            elevation="10"
          >
            <v-layout column wrap justify-center>
              <!-- <h4>
              </h4> -->
              <!-- {{ alert }} -->
              <strong>
                {{ alert.data.message.body }}
              </strong>
            </v-layout>
          </v-alert>
        </v-scale-transition>
      </div>
    </v-layout>
  </div>
</template>
<script>
import { getNotificationMeta } from "@/helpers/notificationTypes";

export default {
  name: "NotificationAlerts",
  data() {
    return {
      snackbar: true,
      timeout: 999999999999999999999999,
      // timeout: 3000000,
    };
  },
  mounted() {
    // console.log("nots", this.notifications);
  },
  computed: {
    notifications() {
      let nots = this.$store.getters["notifications/alerts"];
      nots = JSON.parse(JSON.stringify(nots));
      // console.log("nots", nots);
      return nots;
    },
  },
  methods: {
    alertType(alert) {
      const meta = getNotificationMeta(alert, {
        messageType: alert?.data?.message?.type,
      });
      return meta.vuetifyType;
    },
  },
};
</script>
<style scoped lang="scss">
.notifications {
  z-index: 1000;
  position: fixed;
  width: 100%;
  bottom: 0;
  .notifications-layout {
    .notification {
      width: 100%;
      max-width: 600px;
      padding: 0px 16px;
      text-align: center;
    }
  }
}
</style>
